module.exports = __webpack_public_path__ + "static/media/games.c54ce936.png";